module.exports = __webpack_public_path__ + "static/media/hall-CSC.72d2c034.svg";